<div class="modal-header">
  <h3 class="modal-title">Contribution</h3>
  <button
    type="button"
    class="btn btn-success btn-sm float-end"
    (click)="save()"
    [disabled]="totalEntered === 0 || totalEntered != contribution.totalAmount || !contribution.typeId"
    [hidden]="readonly || !appInfo.neland"
    >
    Save
  </button>
</div>

<div ng-form="dialogForm" class="modal-body clearfix">
  <div class="row">
    <div class="mb-3 col-9">
      <label> Person </label>
      <dx-select-box [(value)]="contribution.personId" [items]="people" valueExpr="id" displayExpr="name" [disabled]="readonly"></dx-select-box>
    </div>
    <div class="control-group col-3"><label> Amount </label> <input type="number" [(ngModel)]="totalEntered" class="form-control" [disabled]="readonly" onmousewheel="return false;"  /></div>
  </div>

  <div class="row">
    <div class="mb-3 col-9">
      <label> Type </label>
      <dx-select-box [(value)]="contribution.typeId" [items]="types" valueExpr="id" displayExpr="name"></dx-select-box>
      <div>
        <button (click)="openCash()" style="margin-left: 10px" accesskey="a"  [hidden]="!appInfo.graafschap || !contribution.personId || contribution.typeId !== 2" class="btn btn-sm btn-primary mt-1"> Batch Cash</button>
      </div>
    </div>

    <div class="mb-3 col-3" [hidden]="contribution.typeId !== 1">
      <label> Check # </label> <input type="text" [(ngModel)]="contribution.checkNumber" class="form-control" [disabled]="readonly" />
    </div>
  </div>

  <table class="table table-condensed table-bordered">
    <thead>
      <tr>
        <th>Account</th>
        <th>Amount</th>
      </tr>
    </thead>
    @if (contribution) {
      <tbody>
        @for (l of contribution.lines; track l) {
          <tr>
            <td style="width: 75%; vertical-align: middle">
              <div [hidden]="l.allowSelect">{{ l.account && l.account.name }}</div>
              <dx-select-box
                [(value)]="l.accountId"
                [items]="otherAccounts"
                valueExpr="id"
                displayExpr="name"
                [hidden]="!l.allowSelect"
                [disabled]="readonly"
              ></dx-select-box>
            </td>
            <td style="width: 25%; padding: 4px">
              <input type="number" [(ngModel)]="l.amount" [disabled]="readonly" class="form-control" style="padding: 8px 4px" onmousewheel="return false;"  />
            </td>
          </tr>
        }
      </tbody>
    }
    <tfoot>
      <tr>
        <td>
          <!-- <a href (click)="addLine()" style="margin-left: 10px" accesskey="a" title="Add Line (Alt-A)" [hidden]="readonly">add account</a> -->
          <button type="button" (click)="addLine()" style="margin-left: 10px" accesskey="a" title="Add Line (Alt-A)" [hidden]="readonly" class="btn btn-link">add account</button>
        </td>
        <td>
          <strong>{{ contribution.totalAmount | currency }}</strong>
        </td>
      </tr>
    </tfoot>
  </table>

  <div class="mb-3"><label> Note </label> <textarea [(ngModel)]="contribution.note" class="form-control" [disabled]="readonly"></textarea></div>
  <div class="mb-3">
    <label style="padding-top: 0">
      <input
        type="checkbox"
        [(ngModel)]="contribution.rmdContribution"
        x-class="form-control"
        [disabled]="readonly"
        style="margin-top: 0; margin-bottom: 3px; margin-right: 5px"
        />RMD Contribution
      </label>
    </div>
  </div>
  <div class="modal-footer">
    <div class="flex-fill">
      <button (click)="delete()" [hidden]="contribution.id < 0" class="btn btn-sm btn-danger me-3" [hidden]="readonly">delete</button>
    </div>
    <button
      type="button"
      class="btn btn-success"
      (click)="save()"
      title="Save (Alt-S)"
      accesskey="s"
        [disabled]="
            totalEntered === 0 || totalEntered != contribution.totalAmount || !contribution.typeId || processing || (contribution.typeId === 1 && !contribution.checkNumber)
        "
      [hidden]="readonly"
      >
      Save
    </button>
    <button type="button" class="btn btn-default" (click)="cancel()">{{ readonly ? 'Close' : 'Cancel' }}</button>
  </div>
